import { memo } from "react";
import { Colors } from "../../utils/colors";
import LandingPagesWrapper from "../../components/LandingPage/LandingPagesWrapper";
import { Icon } from "@iconify/react";
import { MARKITAI } from "@markit/common.utils";

const StripeSuccessfulPage = memo(function StripeSuccessfulPageFn() {
  const styles = {
    headerLabel: {
      fontSize: 22,
      fontWeight: 500,
      paddingBottom: 10,
    },

    headerSubtext: {
      fontSize: 18,
      fontWeight: 500,
      color: Colors.GRAY14,
    },

    headerText: {
      fontSize: 64,
      fontWeight: 500,
      color: Colors.WHITE,
    },
  };

  return (
    <LandingPagesWrapper
      helmetData={{
        title: "Stripe Successful | Markit AI",
        metaContent: "Your Stripe account has been successfully connected.",
        link: MARKITAI + "/stripesuccessful",
      }}
      noRedirect
    >
      <div
        className={"AlignedRowSpaced"}
        style={{
          gap: 80,
          paddingBlock: 250,
          maxWidth: 1152,
          margin: "0 auto",
        }}
      >
        <div className="ColumnNormal">
          <span
            style={{
              ...styles.headerLabel,
              color: Colors.BLUE5,
            }}
          >
            Success!
          </span>
          <div className="ColumnNormal" style={{ gap: 30 }}>
            <h2 style={styles.headerText}>Stripe Connected</h2>
            <p style={{ ...styles.headerSubtext, maxWidth: 460 }}>
              You have successfully connected to Stripe, and your account is
              being reviewed by our team. We will approve your account within 12
              hours (usually much sooner). If you have questions or need this
              expedited for any reason, please contact our support team.
            </p>
            <p style={{ ...styles.headerSubtext, maxWidth: 460 }}>
              You may now close this window.
            </p>
          </div>
        </div>
        <Icon
          icon="ion:shield-checkmark"
          height={150}
          style={{
            color: Colors.WHITE,
          }}
        />
      </div>
    </LandingPagesWrapper>
  );
});

export default StripeSuccessfulPage;
